export { default } from './Home24HeroCPAuto';
